import styled, { css } from "styled-components";
import { responsiveMap } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import FlexBox from "../../FlexBox/FlexBox";

export const _LandingPacmanRoot = styled("div")<{ $aspectRatio?: number }>(
  ({ $aspectRatio: aspectRatio = 21 / 9 }) => {
    return {
      aspectRatio: aspectRatio,
      width: "100%",
      position: "relative",
      // overflow: "hidden",
      [`@media ${responsiveMap.mobile}`]: {
        aspectRatio: "3/4",
      },
      ".landing-pacman-iframe": {
        border: "none",
        aspectRatio: aspectRatio,
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        transform: "translateY(100%)",
        transition: "all 1s cubic-bezier(0.97, 0.15, 0.68, 0.64)",
        [`@media ${responsiveMap.mobile}`]: {
          aspectRatio: "1",
        },

        "&.show": {
          transform: "translateY(0)",
        },
      },
      ".landing-pacman-play": {
        background: 'rgba(0, 0, 0, 0.6)',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: "none",
        color: "#fff",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      },
    };
  }
);

export const _LandingPacmanHeaderContainer = styled(FlexBox)(() => {
  return {
    maxWidth: 700,
    gap: 13,
    padding: "48px 0px 40px 0px",
    [`@media ${responsiveMap.mobile}`]: {
      gap: 8,
      padding: "24px 16px",
    },
  };
});
